import {
  ANALYTIC_EVENT_TYPES,
  INTERACTIONS,
  ANALYTIC_EVENT_EVENTS,
  ANALYTIC_EVENT_CONTEXT,
  ANALYTIC_EVENT_LABELS,
} from '../../constants';
import { NoProductsActionGTM } from '../../events-interfaces';

export const getNoProductsActionEventGTM = (eventLabel: string): NoProductsActionGTM => {
  return {
    event: ANALYTIC_EVENT_TYPES.OWOX,
    eventCategory: INTERACTIONS,
    eventAction: ANALYTIC_EVENT_EVENTS.clickElement,
    eventLabel: eventLabel,
    eventContext: ANALYTIC_EVENT_CONTEXT.sendSuccess,
  };
};

export const getSaveCommentForCourierEvent = () => {
  return {
    event: ANALYTIC_EVENT_TYPES.OWOX,
    eventCategory: INTERACTIONS,
    eventAction: ANALYTIC_EVENT_CONTEXT.sendSuccess,
    eventLabel: 'comment',
    eventContext: ANALYTIC_EVENT_CONTEXT.sendSuccess,
  };
};

export const getSaveCommentForPickerEvent = () => {
  return {
    event: ANALYTIC_EVENT_TYPES.OWOX,
    eventCategory: INTERACTIONS,
    eventAction: ANALYTIC_EVENT_EVENTS.sendSuccess,
    eventLabel: ANALYTIC_EVENT_LABELS.comment,
    eventContext: ANALYTIC_EVENT_EVENTS.sendSuccess,
  };
};
